import { TableHeader as PrimitiveTableHeader } from '@tiptap/extension-table-header'

export const CustomTableHeader = PrimitiveTableHeader.extend({
  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('th')
      const wrapper = document.createElement('div')

      // You can add custom wrapper classes or attributes here
      if (node.attrs.colspan) {
        dom.setAttribute('colspan', node.attrs.colspan)
      }
      if (node.attrs.rowspan) {
        dom.setAttribute('rowspan', node.attrs.rowspan)
      }
      if (node.attrs.colwidth) {
        dom.style.width = node.attrs.colwidth
      }

      dom.classList.add('rt-table-header')
      wrapper.classList.add('rt-table-header-wrapper')
      dom.appendChild(wrapper)
      return {
        dom,
        contentDOM: wrapper,
      }
    }
  },
})
